<div class="btn-group" role="group" [attr.aria-label]="'i18n.domain.theme-showcase.theme.groupLabel' | translate">
  <button
    type="button"
    class="btn btn-outline-secondary"
    [class.active]="(currentThemeMode$ | async) === 'light'"
    (click)="setTheme('light')">
    {{ 'i18n.domain.theme-showcase.theme.light' | translate }}
  </button>
  <button
    type="button"
    class="btn btn-outline-secondary"
    [class.active]="(currentThemeMode$ | async) === 'dark'"
    (click)="setTheme('dark')">
    {{ 'i18n.domain.theme-showcase.theme.dark' | translate }}
  </button>
</div>

